import { createSelector } from 'reselect';
// eslint-disable-next-line import/no-cycle
import CarrierM39ComplianceLocationData from '../../containers/CarrierM39ComplianceLocationData';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import { getPropertyValueByPath } from "../../../../../../react-table/helpers/utils";
import { getReportMode, getReportState } from "../../../../../common/redux/selectors/ReportsSelectors";
import CarrierM39ComplianceLocationColumns from "../../containers/CarrierM39ComplianceLocationColumns";

export const COLUMN_ACCESSOR_CONSIGNMENTS_TOTAL = 'consignments.total';
export const COLUMN_ACCESSOR_RECEPTACLES_TOTAL = 'receptacles.total';

export const HEADER_CONSIGNMENTS = 'consignments';
export const HEADER_RECEPTACLES = 'receptacles';

export const COLUMN_LEAF_EXCLUSIONS = ['postalOperator'];

export const PROPERTY_ORIGINAL_GRAND_TOTAL = 'originalGrandTotal';
export const PROPERTY_ORIGINAL_GROUP_TOTAL = 'originalGroupTotal';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.isLoading;

export const getIsFiltered = state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.filtering &&
  state.reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.filtering.appliedFilters &&
  state.reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.filtering.appliedFilters.some(filter => !filter.value.clearFilter);

export const getData =
  ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.getDataFunction();

export const getOriginalGrandTotal = state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.data
  .map(row => getPropertyValueByPath(row, COLUMN_ACCESSOR_RECEPTACLES_TOTAL)[0])
  .reduce((grandTotal, groupTotal) => grandTotal + groupTotal, 0);

export const getColumns =
  createSelector(
    getData,
    state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.requestParams,
    state => getReportMode(state, ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id),
    CarrierM39ComplianceLocationColumns,
  );

export const getFilteredAndSortedData =
  createSelector(
    state => getReportState(state, ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id),
    getColumns,
    CarrierM39ComplianceLocationData,
  );
